/* eslint-disable jsx-a11y/anchor-is-valid */

import { NavBar } from './styles/NavBar.styled';
import { ShowCaseServices } from './styles/ShowCase.styled';
import { Service } from './styles/Service.styled';
import { Footer } from './styles/Footer.styled';
import logo from './assets/rade-color.png';

const Services = () => {
  return (
    <>
      <NavBar></NavBar>
      <main>
        <ShowCaseServices>
          <div className="center">
            <div className="titleBox">
              <h1>Specialized Cleaning Services</h1>
              <p>
                Rade integrated Services Ltd delivers specialized cleaning
                solutions for your most demanding areas. Leave the deep.
                cleaning to us so you can focus on delivering excellence in your
                business.
              </p>
            </div>
          </div>
        </ShowCaseServices>
        <Service>
          <div className="container">
            <div className="row">
              <img src={logo} alt="" width="150px" height="50px" />
              <h1>Your Solution for Professional Cleaning Services</h1>
              <h3>What We Do</h3>
              <div className="services">
                <div className="service">
                  <img
                    src="https://images.pexels.com/photos/48889/cleaning-washing-cleanup-the-ilo-48889.jpeg?auto=compress&cs=tinysrgb&w=600"
                    alt=""
                  />
                  <div className="content">
                    <h3>Domestic Cleaning</h3>
                    <p>
                      Maintain a clean and organized environment with our
                      regular weekly/Fortnightly/Monthly cleaning services to
                      stay on top of household chores. Our Tailored cleaning
                      schedules to fit your lifestyle, with flexible options.
                    </p>
                    {/* <button>Read More</button> */}
                  </div>
                </div>
                <div className="service">
                  <img
                    src="https://images.pexels.com/photos/1253800/pexels-photo-1253800.jpeg?auto=compress&cs=tinysrgb&w=600"
                    alt=""
                  />
                  <div className="content">
                    <h3>Carpet Cleaning</h3>
                    <p>
                      Revive and rejuvenate your carpets with our professional
                      carpet cleaning services that leave them looking as good
                      as new.
                    </p>
                    {/* <button>Read More</button> */}
                  </div>
                </div>
                <div className="service">
                  <img
                    src="https://images.pexels.com/photos/30465632/pexels-photo-30465632/free-photo-of-abstract-black-and-white-urban-worker-artwork.jpeg?auto=compress&cs=tinysrgb&w=600"
                    alt=""
                  />
                  <div className="content">
                    <h3>Window Cleaning</h3>
                    <p>
                      Get ready to shine! We bring your windows to life with our
                      expert cleaning service.
                    </p>
                    {/* <button>Read More</button> */}
                  </div>
                </div>
                <div className="service">
                  <img
                    src="https://images.pexels.com/photos/213162/pexels-photo-213162.jpeg?auto=compress&cs=tinysrgb&w=600"
                    alt=""
                  />
                  <div className="content">
                    <h3>Oven Cleaning </h3>
                    <p>
                      We remove grease, grime, and burnt residue, restoring
                      shine and efficiency. Our expert oven cleaning service
                      ensures a spotless oven using safe solutions for a
                      healthier kitchen.
                    </p>
                    {/* <button>Read More</button> */}
                  </div>
                </div>
                <div className="service">
                  <img
                    src="https://images.pexels.com/photos/7534297/pexels-photo-7534297.jpeg?auto=compress&cs=tinysrgb&w=600"
                    alt=""
                  />
                  <div className="content">
                    <h3>Hob/Extractor Cleaning</h3>
                    <p>
                      With numerous five-star reviews, we have expertly cleaned
                      a wide range of ovens, including gas and electric, to our
                      sparkling best. If you’re looking for professional oven
                      cleaning near you, look no further than our team.
                    </p>
                    {/* <button>Read More</button> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Service>
      </main>
      <Footer></Footer>
    </>
  );
};

export default Services;
